import Cookies from "js-cookie";

export const AUTH_BACKEND_COOKIE = "dc.auth-backend";

export function getAuthBackendCookie(): "amplify" | "trimble" | undefined {
  const value = Cookies.get(AUTH_BACKEND_COOKIE);
  if (value === "amplify" || value === "trimble") return value;
  return undefined;
}

export function setAuthBackendCookie(value: "amplify" | "trimble"): void {
  const isProduction = process.env.NODE_ENV === "production";
  Cookies.set(AUTH_BACKEND_COOKIE, value, {
    expires: 90,
    path: "/",
    sameSite: isProduction ? "none" : "lax",
    secure: isProduction,
  });
}

export function clearAuthBackendCookie(): void {
  Cookies.remove(AUTH_BACKEND_COOKIE, { path: "/" });
}
